import {
    DEDUCTWALLET,
    CLEAR_HR_REWARDMASTER,
    GETHRREWARDWALLETPASSBOOK,
    GETHRREWARDWALLETWALLET,
    CREATEHRREWARDWALLETPASSBOOK,
    UPDATEHRREWARDWALLETPASSBOOK,
    DELETEHRREWARDWALLETPASSBOOK,

    GETHRREWARDMASTER,
    CREATEHRREWARDMASTER,
    UPDATEHRREWARDMASTER,
    DELETEHRREWARDMASTER,

    CREATEACCOUNTBANKMASTER,
    GETACCOUNTBANKMASTER,
    UPDATEACCOUNTBANKMASTER,
    DELETEACCOUNTBANKMASTER,

    CREATEACCOUNTLEDGERMASTER,
    GETACCOUNTLEDGERMASTER,
    UPDATEACCOUNTLEDGERMASTER,
    DELETEACCOUNTLEDGERMASTER,
    CREATEHOSPITALEEXPENSE,
    CREATEHOSPITALEINCOME,
    DELETEHOSPITALEEXPENSE,
    DELETEHOSPITALEINCOME,
    GETHOSPITALEEXPENSE,
    GETHOSPITALEINCOME,
    UPDATEHOSPITALEEXPENSE,
    UPDATEHOSPITALEINCOME,
    GETACCOUNTLEDGERBYID
} from '../actions/types';

const initialState = {
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

    switch (action.type) {
        case CREATEHOSPITALEINCOME:
            return {
                ...state,
                hospitaleincomeSaveStatus: action.payload.success,
            }
        case GETHOSPITALEINCOME:
            return {
                ...state,
                hospitaleincomeList: action.payload.data,
            }
        case UPDATEHOSPITALEINCOME:
            return {
                ...state,
                hospitaleincomeUpdateStatus: action.payload.success,
            }

        case DELETEHOSPITALEINCOME:
            return {
                ...state,
                hospitaleincomeDeleteStatus: action.payload.success,
            }
        case CREATEHOSPITALEEXPENSE:
            return {
                ...state,
                hospitaleexpenseSaveStatus: action.payload.success,
            }
        case GETHOSPITALEEXPENSE:
            return {
                ...state,
                hospitaleexpenseList: action.payload.data,
            }
        case UPDATEHOSPITALEEXPENSE:
            return {
                ...state,
                hospitaleexpenseUpdateStatus: action.payload.success,
            }

        case DELETEHOSPITALEEXPENSE:
            return {
                ...state,
                hospitaleexpenseDeleteStatus: action.payload.success,
            }

        case GETACCOUNTBANKMASTER: return { ...state, AccountMainBankMasterList: action.payload.data, }
        case CREATEACCOUNTBANKMASTER: return { ...state, AccountMainBankMasterSaveStatus: action.payload.success, }
        case UPDATEACCOUNTBANKMASTER: return { ...state, AccountMainBankMasterUpdateStatus: action.payload.success, }
        case DELETEACCOUNTBANKMASTER: return { ...state, AccountMainBankMasterDeleteStatus: action.payload.success, }
        case GETACCOUNTLEDGERMASTER: return { ...state, AccountMainLedgerMasterList: action.payload.data, }
        case CREATEACCOUNTLEDGERMASTER: return { ...state, AccountMainLedgerMasterSaveStatus: action.payload.success, }
        case UPDATEACCOUNTLEDGERMASTER: return { ...state, AccountMainLedgerMasterUpdateStatus: action.payload.success, }
        case DELETEACCOUNTLEDGERMASTER: return { ...state, AccountMainLedgerMasterDeleteStatus: action.payload.success, }

        case GETACCOUNTLEDGERBYID: return { ...state, AccountLedgerByIdList: action.payload.data, }

        case GETHRREWARDWALLETWALLET: return { ...state, AccountRewardWalletAllWalletList: action.payload.data, }
        case GETHRREWARDWALLETPASSBOOK: return { ...state, AccountRewardWalletPassbookList: action.payload.data, }
        case CREATEHRREWARDWALLETPASSBOOK: return { ...state, AccountRewardWalletPassbookSaveStatus: action.payload.success, }
        case UPDATEHRREWARDWALLETPASSBOOK: return { ...state, AccountRewardWalletPassbookUpdateStatus: action.payload.success, }
        case DELETEHRREWARDWALLETPASSBOOK: return { ...state, AccountRewardWalletPassbookDeleteStatus: action.payload.success, }
        case GETHRREWARDMASTER: return { ...state, AccountRewardMasterList: action.payload.data, }
        case CREATEHRREWARDMASTER: return { ...state, AccountRewardMasterSaveStatus: action.payload.success, }
        case UPDATEHRREWARDMASTER: return { ...state, AccountRewardMasterUpdateStatus: action.payload.success, }
        case DELETEHRREWARDMASTER: return { ...state, AccountRewardMasterDeleteStatus: action.payload.success, }
        case DEDUCTWALLET: return { ...state, AccountRewardWalletDeductStatus: action.payload.success, }

        case CLEAR_HR_REWARDMASTER: return { ...state, AccountRewardMasterList: [] };



        default:
            return state
    }
}